<template>
  <div class="navigation-bread ">
    <span>您所在的位置：</span>
    <a @click="toPage">首页</a>
    <span>&gt;</span>
    <a class="navigation-cur has_theme color_1577FE">{{title}}</a>
  </div>
</template>
<script>
export default {

  props: {
    title: {
      type: String,
      default: ''
    },

  },
  methods: {
    toPage() { this.$router.push('/networking/home'); }
  }
}
</script>
<style lang="scss" scoped>
.navigation-bread {
  margin-bottom: 16px;
  overflow: hidden;

  span,
  a {
    font-size: 16px;
    color: #666666;
    display: block;
    line-height: 21px;
    float: left;
    margin-right: 5px;
  }

  .color_1577FE {
    color: #1577fe;
  }

  .navigation-cur {
    cursor: default;
  }
}
</style>